"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.view.title': 'Onboarding Pracownika',
    'onboarding.view.meet': 'To jest',
    'onboarding.view.new_employee': 'Twój Nowy Pracownik AI',
    'onboarding.view.description.1': 'Z',
    'onboarding.view.description.2': 'tworzenie i publikowanie treści to bułka z masłem.',
    'onboarding.view.description.3': 'W zaledwie kilka minut,',
    'onboarding.view.description.4': 'tworzy strategię treści i całą zawartość na nadchodzące miesiące.',
    'onboarding.view.has_info': 'posiada następujące informacje:',
    'onboarding.view.step': 'Etap',
    'onboarding.view.step1_info': 'Imię, Wiek, Płeć, Głos, Zdjęcie',
    'onboarding.view.knowledge': 'Wiedza',
    'onboarding.view.learning_description': 'dowie się wszystkiego o Twojej firmie, skanując Twoją stronę internetową, media społecznościowe i inne wprowadzone informacje.',
    'onboarding.view.learning_description2': '',
    'onboarding.view.talk_with': 'Rozmawiaj z',
};
